// credits: https://davidwalsh.name/query-string-javascripturl.js
// eslint-disable-next-line
export function query(name) {
  const key = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
  const results = regex.exec(location.search); // eslint-disable-line
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
